<p>offer-dialog works!</p>
